import { render, staticRenderFns } from "./SideNavigationMenu.vue?vue&type=template&id=4227edec&scoped=true"
import script from "./SideNavigationMenu.vue?vue&type=script&lang=js"
export * from "./SideNavigationMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4227edec",
  null
  
)

export default component.exports